import { Component, OnInit, Inject, forwardRef, Input, Optional, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BaseWidget, NgAisInstantSearch, NgAisIndex } from 'angular-instantsearch';
import connectMenu from 'instantsearch.js/es/connectors/menu/connectMenu';
// import * as algoliasearch from 'algoliasearch';
import { VariablesService, UtilService, EventsService } from '../../../shared/services';
// import { environment } from '../../../../environments/environment';
import { CATEGORIES, LOCATIONS, TAGS } from '../filter.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-filter',
  templateUrl: './custom-filter.component.html',
  styleUrls: ['./custom-filter.component.scss']
})
export class CustomFilterComponent extends BaseWidget implements OnInit, OnDestroy {

  declare state: {
    items: { label: string; value: string }[];
    currentRefinement: string;
    createURL: () => string;
    refine: (value: string) => void;
    canRefine: boolean;
    isShowingMore: boolean;
    toggleShowMore: () => void;
    canToggleShowMore: boolean;
  };

  // client = algoliasearch(environment.algolia.id, environment.algolia.key);
  // index = this.client.initIndex(environment.algolia.index);

  @Input() attribute;
  isMobile: any;
  @Input() filterData;
  @Input() resetFilter;
  @Input() origin;

  causeValues = CATEGORIES;
  locationValues = LOCATIONS;
  tagValues = TAGS;
  isCategoryMenuCliked;
  isUserLoggedIn = false;
  subs: Subscription[] = []
  @Output() askLogin = new EventEmitter();

  constructor(
    private vars: VariablesService,
    private util: UtilService,
    @Inject(forwardRef(() => NgAisIndex))
    @Optional()
    public parentIndex: NgAisIndex,
    @Inject(forwardRef(() => NgAisInstantSearch))
    public instantSearchInstance: NgAisInstantSearch,
    public events: EventsService
  ) {
    super('CustomFilterComponent');
  }

  public ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.createWidget(connectMenu, { attribute: this.attribute });
    super.ngOnInit();
    this.subs.push(this.util.isLoggedIn.subscribe(val => {
      this.isUserLoggedIn = val;
    }));

    this.subs.push(this.vars.resetFilter.subscribe((res: any) => {
      if (res) {
        this.resetFilters();
      }
    }));
  }

  resetFilters() {
    this.filterData.cause = 'All Categories';
    this.filterData.tags = 'All Types';
    this.filterData.address = 'All Locations';
  }

  selectedFilter(label, value, type, origin?) {
    if (this.isUserLoggedIn) {
      if (this.filterData.cause === label) { return; }
      this.events.userGTMEvents({
        event: 'search',
        event_category: 'search',
        event_action: `${origin || ''} category click`,
        event_label: label
      });
      if (origin === 'categoryMenu') {
        this.vars.isCategoryMenuCliked = true;
      }
      if (this.isMobile) {
        this.util.openSnackBar('Filter applied.', 'success', {
          duration: 1000
        });
      }
      // this.vars.showApply.next(true);
      if (type === 'cause') {
        this.filterData.cause = label;
        // if (origin === 'sidemenu' && !this.vars.isCategoryMenuCliked) {
        //   this.filterData.tags = 'All Types';
        // }
      } else if (type === 'tags') {
        this.filterData.tags = label;
      } else if (type === 'address') {
        this.filterData.address = label;
      }
      this.state.refine(value);
      this.vars.resetCounter.next(true);
    } else {
      this.askLogin.emit('filter');
    }

  }

  ngOnDestroy(): void {
    if (this.subs.length > 0) {
      this.subs.forEach(sub => sub.unsubscribe());
    }
  }

}
